import React from 'react';
import { useAuth } from '../providers/AuthProvider';

// props.branches = { admin: PageAdmin, manager: PageManager}
//
export const PagePermissionSwitch = (props: any) => {
  const auth = useAuth();
  const isAdmin = auth.isAdmin();
  const { cases } = props;
  let Component;
  if (isAdmin) {
    Component = cases.admin;
  } else {
    Component = cases.manager;
  }
  if (!Component) {
    return null;
  }
  return <Component />;
};

export default PagePermissionSwitch;
